import React, { useRef, useState } from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { format } from "date-fns";
import "./dateSelector.css";
import { FaRegCalendarAlt } from "react-icons/fa";
import { Room } from "../HotelBookingPage";

interface DateSelectorProps {
  checkIn: Date | null;
  checkOut: Date | null;
  setCheckIn: (date: Date | null) => void;
  setCheckOut: (date: Date | null) => void;
  selectedRoom: Room | null; // ← Add this
}

const DateSelector: React.FC<DateSelectorProps> = ({
  checkIn,
  checkOut,
  setCheckIn,
  setCheckOut,
  selectedRoom, // ← Add this
}) => {
  const [activeField, setActiveField] = useState<"from" | "to" | null>(null);
  const isLimitedSuite =
    selectedRoom &&
    ["King Deluxe Suite", "King Executive Suite"].includes(selectedRoom.name);

  const normalize = (d: Date) =>
    new Date(d.getFullYear(), d.getMonth(), d.getDate());

  const handleSelect = (date?: Date | { from?: Date; to?: Date }) => {
    if (!date) return;

    if (activeField === "from" && date instanceof Date) {
      const normalized = normalize(date);
      if (
        normalized >= new Date(2025, 10, 13) && // Nov 12
        normalized <= new Date(2025, 10, 15) // Nov 14
      ) {
        setCheckIn(date);
        setCheckOut(null);
        setActiveField(null);
      }
      return;
    }

    if (activeField === "to" && date instanceof Date) {
      const normalized = normalize(date);
      if (
        normalized >= new Date(2025, 10, 15) && // Nov 15
        normalized <= new Date(2025, 10, 18) // Nov 18
      ) {
        setCheckOut(date);
        setActiveField(null);
      }
    }
  };

  return (
    <div
      className="smooth-range-wrapper"
      style={{ marginLeft: 40, marginRight: 40 }}
    >
      <div className="mobile-date-label">
        <span>Check-in Date</span>
      </div>

      <div className="input-row">
        <div className="input-container">
          <div className="date-field">
            <label className="input-label">From</label>
            <div
              className="input-with-icon"
              onClick={() => setActiveField("from")}
            >
              <div
                className="input-wrapper"
                onClick={() => setActiveField("from")}
              >
                <FaRegCalendarAlt className="calendar-icon" />
                <input
                  type="text"
                  readOnly
                  value={checkIn ? format(checkIn, "MMMM d, yyyy") : ""}
                  className="styled-input with-icon"
                />
              </div>
            </div>
          </div>

          <div
            className={`calendar-popup ${activeField === "from" ? "open" : ""}`}
          >
            {activeField === "from" && (
              <DayPicker
                mode="single"
                selected={checkIn ?? undefined}
                onSelect={handleSelect}
                defaultMonth={checkIn ?? new Date("2025-11-01")}
                fromDate={new Date("2025-11-13")}
                toDate={new Date("2025-11-14")}
                showOutsideDays={false}
                fixedWeeks
                disabled={[
                  { before: new Date("2025-11-13") },
                  { after: new Date("2025-11-15") },
                ]}
              />
            )}
          </div>
        </div>

        <div className="input-container">
          <div className="date-field">
            <label className="input-label">To</label>
            <div
              className="input-with-icon"
              onClick={() => setActiveField("to")}
            >
              <div
                className="input-wrapper"
                onClick={() => setActiveField("from")}
              >
                <FaRegCalendarAlt className="calendar-icon" />
                <input
                  type="text"
                  readOnly
                  value={checkOut ? format(checkOut, "MMMM d, yyyy") : ""}
                  className="styled-input with-icon"
                />
              </div>
            </div>
          </div>

          <div
            className={`calendar-popup ${activeField === "to" ? "open" : ""}`}
          >
            {activeField === "to" && (
              //   <DayPi
              <DayPicker
                mode="single"
                selected={checkOut ?? undefined}
                onSelect={handleSelect}
                defaultMonth={checkOut ?? new Date("2025-11-01")}
                fromDate={new Date("2025-11-15")}
                toDate={new Date("2025-11-18")}
                showOutsideDays={false}
                fixedWeeks
                disabled={[
                  { before: new Date("2025-11-15") },
                  ...(isLimitedSuite
                    ? [{ after: new Date("2025-11-16") }] // block 17–18 for suites
                    : [{ after: new Date("2025-11-18") }]),
                ]}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DateSelector;
